import React, { ReactNode } from "react"
import { Link as RouterLink } from "react-router-dom"
import Icon from "components/elements/Icon"
import Link from "components/elements/Link"
import { Box } from "@chakra-ui/react"
import { RoundedListItem } from "./RoundedList"

interface LinkListItemProps {
  title: string | ReactNode
  description?: string | ReactNode
  icon?: ReactNode
  to?: string
  href?: string
  isExternal?: boolean
  onClick?: () => void
}

const LinkListItem = ({
  title,
  description,
  icon,
  to,
  href,
  isExternal = false,
  onClick,
}: LinkListItemProps) => {
  const chevron = (
    <Icon
      icon="next-arrow"
      size={3}
      ml={5}
      color="gray.500"
    />
  )

  const content = (
    <Box _hover={{ backgroundColor: "gray.50" }} width="100%">
      <RoundedListItem
        text1={title}
        text2={description}
        icon={icon}
        action={chevron}
      />
    </Box>
  )

  if (onClick) {
    return (
      <Box as="button" type="button" width="100%" textAlign="left" onClick={onClick}>
        {content}
      </Box>
    )
  }

  if (isExternal && href) {
    return (
      <Link href={href} color="gray.800" textDecoration="none" isExternal>
        {content}
      </Link>
    )
  }

  return (
    <RouterLink to={to || "#"} style={{ color: "inherit", textDecoration: "none" }}>
      {content}
    </RouterLink>
  )
}

export default LinkListItem
